<template>
  <div class="container">
    <custom-select
      label="Franja horaria"
      :value="value"
      @input="onChange"
      :items="franjas"
    />
  </div>
</template>

<script>
import { franjasHorarias } from "@/config/constants/index";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "TimeRange",
  components: { CustomSelect },
  props: {
    value: String
  },
  computed: {
    franjas() {
      return franjasHorarias;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
